import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import moment, { Moment } from 'moment'

import Spinner from '../../App/Components/Spinner/Spinner'
import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

import Client from './Client/Client'
import Table from './Table'

const HRTime: FunctionComponent = () => {
    const { t } = useTranslation()
    const [data, setData] = useState(null)
    const [from, setFrom] = useState<Moment>(moment().startOf('isoWeek'))
    const [to, setTo] = useState<Moment>(moment().endOf('isoWeek'))

    const fetchData = async () => {
        const newData = await Client.getData(from, to)
        setData(newData)
    }

    useEffect(() => {
        fetchData()
    }, [from, to])

    return (
        <>
            <h1>{t('Time report')}</h1>
            <a
                href={`/hr-time/print/${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}`}
                className={'button margin-bottom-medium'}
                target={'_blank'}
            >
                {t('Print')}
            </a>

            <DateRangeSelection
                onSelected={(range, selectedFrom, selectedTo) => {
                    setFrom(selectedFrom)
                    setTo(selectedTo)
                }}
                from={from}
                to={to}
                span={'week'}
            />

            {data ? (
                <Table result={data.result} from={from} to={to} />
            ) : (
                <Spinner />
            )}
        </>
    )
}

export default HRTime
